import Input from './Input'
import RadioGroup from './RadioGroup'
import Select from './Select'
import Checkbox from './Checkbox'
import CheckboxGroup from './CheckboxGroup'
import DatePicker from './DatePicker'
import Button from './Button'

const Controls = {
    Input,
    RadioGroup,
    Select,
    Checkbox,
    CheckboxGroup,
    DatePicker,
    Button,
}

export default Controls
